module.exports = __webpack_public_path__ + "public/images/calendar.d6ddc6c2e6e39f0aedfd4769385e3869.png";